//libs
import React, { memo } from 'react';
//components
import SimilarItems from '@nykaa/ui-components/Icons/similar-items';

import { ViewSimilarButton } from './styles';

interface ViewSimilar {
  className: string;
  onClick: (event: MouseEvent) => void;
}

const ViewSimilar = ({ className = '', onClick }: ViewSimilar) => {
  return (
    <ViewSimilarButton onClick={onClick} className={`circle ${className}`}>
      <SimilarItems />
    </ViewSimilarButton>
  );
};

export default memo(ViewSimilar);
